const initialState = {
  setTarget: false,
  statusInputTarget: true,
  closeTabTargetKorwil: false,
  statusInputTargetProduktif: true,
  listKorwil: [],
  listTargetKorwil: [],
  listTargetKorwilProduktif: [],
};

const korwilReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB_TARGET_KORWIL":
      return {
        ...state,
        closeTabTargetKorwil: data,
      };
    case "SET_ALLKORWIL":
      return {
        ...state,
        listKorwil: data,
      };
    case "SET_STATUS_INPUT_TARGET_KORWIL":
      return {
        ...state,
        statusInputTarget: data,
      };
    case "SET_ALL_TARGET_KORWIL":
      return {
        ...state,
        listTargetKorwil: data,
      };
    case "SET_ALL_TARGET_KORWIL_PRODUKTIF":
      return {
        ...state,
        listTargetKorwilProduktif: data,
      };
    case "SET_STATUS_INPUT_TARGET_KORWIL_PRODUKTIF":
      return {
        ...state,
        statusInputTargetProduktif: data,
      };
    default:
      return state;
  }
};
export default korwilReducer;
